import { persistPortalContext, type PortalContext } from './portalContext'

export function navigateToPortal(
  path: string,
  navigate: (url: string) => void = (url) => window.location.assign(url),
) {
  navigate(new URL(path, window.location.origin).href)
}

export function switchPortalAccount(
  userId: string,
  context: PortalContext,
  navigate: (url: string) => void,
) {
  persistPortalContext(userId, context)
  const path = context.kind === 'organization' ? '/org/audio' : '/dashboard'
  navigateToPortal(path, navigate)
}
